module.exports = __webpack_public_path__ + "media/src/images/abouts/cards/season/2009_tosyo-cddb2316f2deb16a4c129c6c99049a8c.jpg";